import BaseResource from '@/lib/data/resource/BaseResource'

export default class NIIExtremeEventOptionResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Title = payload.eventName ?? ''
    this.Value = payload.eventCode ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
